const MenuElementHOC = props => {
    return props.children;
}

export default MenuElementHOC;
